/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import Head from 'next/head';
import { sanitizeHtmlForSSR } from '../../utils/html-sanitizer';

export default function CourseSpecifications({ title = '', subtitle = '', content }) {
  // Sanitize and memoize the HTML content for SSR safety
  const sanitizedData = useMemo(() => {
    if (!content) return null;
    return sanitizeHtmlForSSR(content);
  }, [content]);

  // Early return if no content
  if (!sanitizedData || !sanitizedData.content) {
    return null;
  }

  return (
    <>
      <Head>
        {sanitizedData.externalLinks.map((href) => (
          <link key={href} rel="stylesheet" href={href} />
        ))}
        {sanitizedData.styles && (
          <style dangerouslySetInnerHTML={{ __html: sanitizedData.styles }} />
        )}
      </Head>
      <section className="w-full flex flex-col items-between gap-[24px] sm:gap-[36px] md:gap-[40px] sm:mt-[16px] md:mt-[10px] px-2">
        {/* {heading && (
          <header className="flex items-start gap-[10px] sm:gap-[12px] justify-center px-4">
            <div className="w-[6px] h-[28px] md:h-[32px] bg-[#ff5761] mt-[6px]" />
            <h2 className="text-[30px]  font-semibold leading-[32px] sm:leading-[38px] md:leading-[45px] text-black text-center">
              {heading}
            </h2>
          </header>
        )} */}
        {
          (title || subtitle)
          && (
          <div className="w-full flex flex-col items-center text-center mb-1">
            {title && <div dangerouslySetInnerHTML={{ __html: title }} />}
            {subtitle && <div dangerouslySetInnerHTML={{ __html: subtitle }} />}
          </div>
          )
        }
        <div className="w-full flex flex-col gap-[16px] sm:gap-[20px] shadow-[1px_5px_50px_#54637a19] border border-[#b7e5ff] bg-white" dangerouslySetInnerHTML={{ __html: sanitizedData.content }} />
      </section>
    </>
  );
}

CourseSpecifications.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  content: PropTypes.string,
};
